import { Color, ColorDynamic } from '@superdispatch/ui';
import { Button } from '@superdispatch/ui-lab';
import styled from 'styled-components';

export const DownloadButton = styled(Button)`
  @media print {
    display: none;
  }
`;

export const PhotoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
  position: relative;

  ${({ theme }) => theme.breakpoints.up('md')} {
    &[data-direction='horizontal'] {
      grid-template-columns: repeat(5, 1fr);
      grid-auto-flow: column;
    }
  }
`;

export const PhotoGridItem = styled.div<{ $isLarge?: boolean }>`
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  cursor: pointer;
  background-color: ${ColorDynamic.Silver400};

  ${({ $isLarge }) =>
    $isLarge &&
    `
    grid-column: 1 / 3;
    grid-row: 1 / 3;
  `}

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const PhotoGridContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const MorePhotosBadge = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: ${Color.White};
`;

export const VideoContainer = styled.div`
  position: absolute;
  z-index: 2;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const VideoDuration = styled.div`
  z-index: 2;
  position: absolute;
  bottom: 4px;
  right: 4px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 2px;
  padding: 2px;
  color: white;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const VideoWrapper = styled.div`
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NonVehiclePhotoBadge = styled.div`
  position: absolute;
  top: 0;
  z-index: 2;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6);
`;
